import React, { Fragment, useEffect, useState, useContext } from 'react';
import { map } from 'lodash';
import renderRawHtml from '../../../../common/render_raw_html';
import { splitTextAndImages, imageSrc } from '../logic/qualify_helper';
import { baseContext } from '../contexts';
import ZoomImage from './zoom_image';

const TextWithImages = ({ className, content }) => {
  const { cdnHost } = useContext(baseContext);
  const getTextAndImagesArray = () => (splitTextAndImages(content));
  const [ textAndImages, setTextAndImages ] = useState(getTextAndImagesArray);
  useEffect(() => {
    setTextAndImages(getTextAndImagesArray());
  }, [ content ]);

  return (
    <>
      {
        map(textAndImages.content, (item, index) => {
          const { src, alt } = imageSrc(item, textAndImages.images, cdnHost);
          return (
            <Fragment key={ `contentItem${index}` }>
              { !src && <div className={ className }  { ...renderRawHtml(item) } /> }
              {
                !!src &&
                <ZoomImage
                  withHeadWrapper
                  className="survey-start-hero-img -no-top-margin -no-margin"
                  src={ src }
                >
                  <img src={ src } alt={ alt } />
                </ZoomImage>
              }
            </Fragment>
          );
        })
      }
    </>
  );
};

export default TextWithImages;
